import DeleteIcon from "@mui/icons-material/Delete"
import AttachFileIcon from "@mui/icons-material/AttachFile"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
import { Box, IconButton } from "@mui/material"
import Chip from "@mui/material/Chip"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import ArticleDialog from "../../solutions/ArticleDialog"
import CategoryDialog from "../../solutions/CategoryDialog"
import SubCategoryDialog from "../../solutions/SubCategoryDialog"
import TicketFeedback from "./../TicketFeedback"
import TicketIdLinkView from "./TicketIdLinkView"
import {MERGED} from '../../../Constants/StatusConstants'

// Refer to GridBaseColDef

const statusColors = {
    open: "#007BFF",
    "in-progress": "#FD7E14",
    hold: "#FFC107",
    resolved: "#20C997",
    closed: "#6C757D",
    reopen: "#007BFF",
}

export const TICKETS_COLUMNS = [
    {
        field: "id",
        headerName: "Ticket ID",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
            const mergeTicketStatus = (params.row?.mergeTicket &&  params.row?.mergeTicket!== MERGED)|| ""
            return (
                <TicketIdLinkView
                    id={params.value}
                    mergeStatus={mergeTicketStatus}
                    mergedTicketId={params.row?.mergeTicket}
                />
            )
        },
    },
    {
        field: "priority",
        headerName: "Priority",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "subject",
        headerName: "Subject",
        flex: 1,
        minWidth: 150,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        filterable: false,
        sortable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "impact",
        headerName: "Impact",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "urgency",
        headerName: "Urgency",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "ticketCategory",
        headerName: "Ticket Category",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "requestType",
        headerName: "Request Type",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
            return (
                <Chip
                    label={params.value}
                    color="white"
                    sx={{
                        backgroundColor:
                            statusColors[params.value.toLowerCase()],
                        color: "white",
                    }}
                    size="small"
                />
            )
        },
    },
    {
        field: "resolverGroup",
        headerName: "Resolver Group",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "resolver",
        headerName: "Resolver",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.user?.name,
    },
    {
        field: "createdBy",
        headerName: "CreatedBy",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "beHalfOfUser",
        headerName: "On BeHalf Of",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "organization",
        headerName: "Organization",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value,
    },
    {
        field: "createdOn",
        headerName: "CreatedOn",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "modifiedOn",
        headerName: "Last Modified On",
        flex: 1,
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => params.value?.name,
    },
    {
        field: "",
        headerName: "Feedback",
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
            return <TicketFeedback ticketId={params.row.id} status={params.row?.status} />
        },
    },
]

export const SOLUTIONS_ARTICLES_COLUMNS = function (bindFunctions) {
    return [
        {
            field: "id",
            headerName: "Article ID",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <ArticleDialog
                        articleId={params.value}
                        selectedArticleName={params.value}
                        callArticles={bindFunctions.getArticles}
                        componentPermissions={
                            bindFunctions.componentPermissions
                        }
                        actionType={bindFunctions.actionType}
                        isEdit={true}
                    />
                )
            },
        },
        {
            field: "title",
            headerName: "Article Name",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value}>
                        <span
                            style={{
                                display: "block",
                                maxWidth: 200,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {params.value}
                        </span>
                    </Tooltip>
                )
            },
        },
        {
            field: "subCategory",
            headerName: "Sub Category",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value?.name}>
                        <span
                            style={{
                                display: "block",
                                maxWidth: 200,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {params.value?.name}
                        </span>
                    </Tooltip>
                )
            },
        },
        {
            field: "category",
            headerName: "Category",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value?.name}>
                        <span
                            style={{
                                display: "block",
                                maxWidth: 200,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {params.value?.name}
                        </span>
                    </Tooltip>
                )
            },
        },
        {
            field: "summary",
            headerName: "Description",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
                return <Tooltip title={params.value}>{params.value}</Tooltip>
            },
        },
        {
            field: "active",
            headerName: "Active",
            flex: 1,
            minWidth: 50,

            renderCell: (params) => {
                const statusColors = {
                    false: "error",
                    true: "success",
                };
                return (
                    <Chip
                        label={params.value ? "Yes" : "No"}
                        color={statusColors[params.value]}
                        size="small"

                    />

                )
            },

        },
    ]
}

export const SOLUTIONS_SUB_CATEGORY_COLUMNS = function (bindFunctions) {
    return [
        {
            field: "name",
            headerName: "Sub Category Name",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <SubCategoryDialog
                        subCategoryId={params.row.id}
                        selectedSubCategoryName={params.value}
                        callSubCategories={bindFunctions.getSubCategories}
                        componentPermissions={
                            bindFunctions.componentPermissions
                        }
                        actionType={bindFunctions.actionType}
                        isEdit={true}
                    />
                )
            },
        },
        {
            field: "category",
            headerName: "Category",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value?.name}>
                        <span
                            style={{
                                display: "block",
                                maxWidth: 200,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {params.value?.name}
                        </span>
                    </Tooltip>
                )
            },
        },
        {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
                return <Tooltip title={params.value}>{params.value}</Tooltip>
            },
        },
        {
            field: "active",
            headerName: "Active",
            flex: 1,
            minWidth: 50,
            renderCell: (params) => {
                const statusColors = {
                    false: "error",
                    true: "success",
                };
                return (
                    <Chip
                        label={params.value ? "Yes" : "No"}
                        color={statusColors[params.value]}
                        size="small"

                    />

                )
            },
        },
    ]
}

export const SOLUTIONS_CATEGORY_COLUMNS = function (bindFunctions) {
    return [
        {
            field: "name",
            headerName: "Category Name",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <CategoryDialog
                        categoryId={params.row.id}
                        selectedCategoryName={params.value}
                        callCategories={bindFunctions.getCategories}
                        componentPermissions={
                            bindFunctions.componentPermissions
                        }
                        actionType={bindFunctions.actionType}
                        isEdit={true}
                    />
                )
            },
        },
        {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
                return <Tooltip title={params.value}>{params.value}</Tooltip>
            },
        },
        {
            field: "active",
            headerName: "Active",
            flex: 1,
            minWidth: 50,
            renderCell: (params) => {
                const statusColors = {
                    false: "error",
                    true: "success",
                };
                return (
                    <Chip
                        label={params.value ? "Yes" : "No"}
                        color={statusColors[params.value]}
                        size="small"

                    />

                )
            },
        },
    ]
}

export const USER_GROUPS_COLUMNS = [
    {
        field: "groupName",
        headerName: "Group Name",
        flex: 1,
        disableColumnMenu: true,
        renderCell: (params) => params.value,
    },
    {
        field: "groupType",
        headerName: "Group Type",
        flex: 1,
        disableColumnMenu: true,
        renderCell: (params) => params.value,
    },
]

export const EMAIL_QUEUE_COLUMNS = [
    {
        field: "from",
        headerName: "From",
        flex: 1,
        minWidth: 180,
        sortable: false,
        renderCell: (params) => (
            <Box display="flex" alignItems="center">
                <MailOutlineIcon fontSize="small" sx={{ mr: 1 }} />
                {params.value}
            </Box>
        ),
    },
    {
        field: "subject",
        headerName: "Subject",
        flex: 1,
        minWidth: 180,
        sortable: false,
        renderCell: (params) => <b>{params.value}</b>,
    },
    {
        field: "body",
        headerName: "Message",
        flex: 2,
        minWidth: 220,
        sortable: false,
        renderCell: (params) => (
            <Tooltip title={params.value}>
                <Typography noWrap sx={{ maxWidth: 220 }}>
                    {params.value}
                </Typography>
            </Tooltip>
        ),
    },
    {
        field: "inboxAttachmentDTOs",
        headerName: "Files",
        flex: 1,
        minWidth: 120,
        sortable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
            const attachments = params.value || []
            if (attachments.length === 0) return "-"
            return attachments.map((file, idx) => (
                <Tooltip key={idx} title={file.fileName}>
                    <Chip
                        icon={<AttachFileIcon />}
                        label={file.fileName}
                        size="small"
                        sx={{ mr: 0.5 }}
                    />
                </Tooltip>
            ))
        },
    },
]

export const USER_ROLES_COLUMNS = [
    {
        field: "role.name",
        headerName: "Role",
        align: "center",
        headerAlign: "center",
        flex: 1,
        disableColumnMenu: true,
        renderCell: (params) => params.row?.role?.name,
    },
]
export const ADD_USERS_TO_GROUP_COLUMNS = function (bindFunctions) {
    return [
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            disableColumnMenu: true,
            renderCell: (params) => params.row?.name,
        },
        // {
        //   field: "resolverGroup.name",
        //   headerName: "Group",
        //   flex: 1,
        //   disableColumnMenu: true,
        //   renderCell: (params) => params.row?.resolverGroup?.name,
        // },
        {
            field: "id",
            headerName: "Action",
            flex: 1,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <IconButton
                        edge="end"
                        onClick={() =>
                            bindFunctions.handleDeleteUserRole(params.value)
                        }
                    >
                        <DeleteIcon />
                    </IconButton>
                )
            },
        },
    ]
}
